import CountryRepository, {
  CommunicationCultureCountry,
} from '../repositories/CountryRepository';
import MockCountryRepository from '../repositories/__mocks__/CountryRepository';
import BenefitsRepository from '../repositories/BenefitsRepository';
import Country from '../entities/Country';
import Benefit from '../entities/Benefit';
import { CountryCode } from '../../hocs/withInitialData';
import { config } from '../../../config';
export default class CountryDataService {
  private countryRepository: CountryRepository;
  private benefitsRepository: BenefitsRepository;
  private static instance: CountryDataService;

  static getInstance(): CountryDataService {
    if (CountryDataService.instance) return CountryDataService.instance;
    CountryDataService.instance = config.isLocalhost
      ? new CountryDataService(
          new MockCountryRepository(),
          new BenefitsRepository()
        )
      : new CountryDataService(
          new CountryRepository(),
          new BenefitsRepository()
        );
    return CountryDataService.instance;
  }

  constructor(
    countryRepository: CountryRepository,
    benefitsRepository: BenefitsRepository
  ) {
    this.countryRepository = countryRepository;
    this.benefitsRepository = benefitsRepository;
  }

  async getCountriesData(): Promise<Country[]> {
    const [comCultureCountries, benefits] = await Promise.all([
      this.countryRepository.fetchAll(),
      this.benefitsRepository.fetchAll(),
    ]);

    const countries: Country[] = [];
    if (benefits && comCultureCountries) {
      for (const comCultureCountry of comCultureCountries) {
        countries.push(this.toEntity(comCultureCountry, benefits));
      }
    }
    return countries;
  }

  toEntity(
    comCultureCountry: CommunicationCultureCountry,
    benefits: Benefit[]
  ): Country {
    const country = {
      name: comCultureCountry.name,
      code: comCultureCountry.code,
      nativeName: comCultureCountry.nativeName,
      benefits: this.setCountryBenefits(comCultureCountry.code, benefits),
    };

    return country;
  }

  isFeatureFlagAvailable(
    featureFlag: CountryCode[],
    code: CountryCode
  ): boolean {
    return featureFlag.includes(code.toUpperCase());
  }

  setCountryBenefits(code: CountryCode, benefits: Benefit[]): string[] {
    const countryBenefits = [];
    for (const benefit of benefits) {
      !this.isBenefitBlacklisted(benefit, code)
        ? countryBenefits.push(benefit.id)
        : '';
    }
    return countryBenefits;
  }
  isBenefitBlacklisted(benefit: Benefit, code: CountryCode): boolean {
    return benefit.blacklist.includes(code.toUpperCase());
  }
  getCountry(countries: Country[], countryCode: string): Country | null {
    for (const country of countries) {
      if (country.code.toLowerCase() === countryCode.toLowerCase())
        return country;
    }
    return null;
  }

  isBenefitAvailable(country: Country, benefit: string): boolean {
    return !!country?.benefits?.includes(benefit);
  }
}
